<template>
  <div
    :style="{
      width: this.width,
      minWidth: this.width,
    }"
  >
    <div
      class="navBtn"
      @mouseenter="changeColor"
      @mouseleave="resetColor"
      :class="{
        highlightSelected: this.selectHighlight,
      }"
    >
      <div
        class="navIconBtn"
        :class="{
          selectedBtn: this.isSelected,
        }"
      >
        <Icon
          :icon="icon"
          :hexCode="this.isSelected ? colorHex : '#000000'"
          :size="s"
          stroke="1.5"
        />
      </div>
      <div
        v-if="text"
        :class="{
          moonBlue: this.isSelected,
          fullWidth: this.isSideBar,
        }"
        class="navText"
      >
        {{ text }}
      </div>
    </div>
    <!-- <div v-if="isSelected" class="bottomLine"></div> -->
    <!-- <div v-else class="emptyBottomLine"></div> -->
  </div>
</template>

<script>
import Icon from "../utilities/Icon.vue";

export default {
  name: "NavButton",
  props: {
    text: String,
    width: String,
    icon: Function,
    icon_size: String,
    isSelected: Boolean,
    isSideBar: Boolean,
    selectHighlight: Boolean,
  },
  components: {
    Icon,
  },
  data() {
    return {
      colorHex: this.isSelected ? "#721cff" : "#000000",
      s: this.icon_size ? this.icon_size : "22",
    };
  },
  methods: {
    changeColor() {
      this.colorHex = "#721cff";
    },
    resetColor() {
      if (!this.isSelected) this.colorHex = "#000000";
    },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.navBtn {
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
  margin: 3px 7px;
  min-height: 18px;
  min-width: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none !important;
  padding: 5px 8px;
  /* width: 170px; */
}
/* .navIconBtn {
  padding: 5px 8px;
  border-radius: 7px;
  margin-right: 5px;
} */
/* .selectedBtn {
  outline: thin solid #dadada;
  background: #e6e6e6;
} */
.wholeNavBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.navBtn:hover {
  outline: thin solid #dadada;
}
.bottomLine {
  margin-top: 1px;
  height: 3px;
  width: calc(100% - 20px);
  background: #721cff;
  border-radius: 2px;
}
.emptyBottomLine {
  margin-top: 1px;
  height: 3px;
}
.moonBlue {
  color: #721cff !important;
}
.fullWidth {
  width: 130px;
  min-width: 130px;
}
.navText {
  color: #636363;
  margin-left: 13px;
}
.navBtn:hover .navText {
  color: black;
}
/* .navBtn:hover .selectedBtn {
  outline: thin solid transparent;
  background: transparent;
} */
.highlightSelected {
  background: #721cff40;
  border-radius: 7px;
  outline: thin solid #721cff80;
}
.highlightSelected:hover {
  background: #721cff40;
  outline: thin solid #721cff80;
}
</style>
